export const BUILD_VERSION = '1787937347';
